<template>
  <div class="con">
    <div class="info">
      <div>
        <span>单买四条轮胎的总价：</span>
        <span>¥ {{ infoArr?.factoryGuidePriceTotal }}</span>
      </div>
      <div class="padSty">
        <span>购买轮胎套餐后四条轮胎的总价：</span>
        <span>¥ {{ infoArr?.discountPriceTotal }} （含购买此计划的费用）</span>
      </div>
      <div class="colorSty">
        <span>轮胎套餐预计节省：</span>
        <span>¥ {{ infoArr?.projectedSavingsPrice }}</span>
      </div>
    </div>
    <van-collapse v-model="planDiscrption" accordion>
      <van-collapse-item title="轮胎套餐预计节省详情" name="1">
        <div>
          <van-row gutter="5" justify="center" class="rowTab">
            <van-col span="4">权益名称</van-col>
            <van-col span="5">权益类型</van-col>
            <van-col span="5">购买轮胎套餐后客户支付价格</van-col>
            <van-col span="5">单条轮胎星徽菜单建议零售价（含工时费）</van-col>
            <van-col span="5">单条轮胎节省金额</van-col>
          </van-row>
          <van-row gutter="5" justify="center" class="rowTabcon" v-for="(item, index) in infoArr?.tyreLoyaltyCouponEntityList" :key="index">
            <van-col span="4"
              ><span style="display:inline-block; width: 50px;word-break: break-word;white-space:normal">{{ item.rightName }}</span></van-col
            >
            <van-col span="5">
              <div>
                <span>{{ item.rightTypeName }}</span>
                <div v-if="item.rightTypeFlag == 9" style="width: 60px;word-break: break-word;white-space:normal">
                  （需收取计划费用
                  {{ filterPrice(infoArr?.uniformPrice || infoArr?.revisedPrice) }}
                  ）
                </div>
              </div>
            </van-col>
            <van-col span="5">
              <span>{{ filterPrice(item.discountAmount) }}</span></van-col
            >
            <van-col span="5">
              <div style="width: 90px;word-break: break-word;white-space:normal">
                <span>{{ filterPrice(item.factoryGuidePrice) }}</span>
                <!-- <span v-if="productItem.partType==3 || productItem.partType==4">（含工时费 ¥395.00）</span> -->
              </div>
            </van-col>
            <van-col span="5">
              <span>{{ filterPrice(item.amountSaved) }}</span></van-col
            >
          </van-row>
        </div>
      </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script>
import { reactive, toRefs, onMounted, watch } from 'vue'
import { useStore } from 'vuex'
import { getPlanPriceByCustomer } from '@/api/tyre'
export default {
  // props:['productItem'],
  setup(props, { emit }) {
    //  let {productItem}= toRefs(props)
    const store = useStore()
    let { loyaltyId, dealerInfo, brandInfo, currentGoodsInfo } = store.state
    const state = reactive({
      planDiscrption: '',
      productItem: brandInfo,
      infoArr: []
    })
    watch(
      () => store.state.brandInfo,
      n => {
        if (n && n.productNo) {
          state.productItem = n
          getData()
        }
      },
      { deep: true }
    )
    // watch(
    //   () => state.productItem,
    //   n => {
    //     if (n) {
    //       getData()
    //     }
    //   },
    //   { deep: true }
    // )
    onMounted(() => {
      getData()
    })
    const filterPrice = value => {
      let r = '-'
      if (value != undefined && value != '-') {
        r = `¥ ${value}`
      }
      return r
    }
    const getData = async () => {
      let params = {
        loyaltyId,
        qrcodeHistoryId: currentGoodsInfo.qrcodeHistoryId ? currentGoodsInfo.qrcodeHistoryId : null,
        gsCode: dealerInfo.gs_code || dealerInfo.gsCode,
        productNo: state.productItem.productNo || '',
        baumuster: state.productItem.proItem.baumuster || '',
        finStart: state.productItem.proItem.finStart || '',
        finEnd: state.productItem.proItem.finEnd || ''
      }
      const res = await getPlanPriceByCustomer(params)
      state.infoArr = res
      emit('on-get-uniformPrice', res.uniformPrice);
    }
    return {
      ...toRefs(state),
      filterPrice,
      getData
    }
  }
}
</script>

<style lang="scss" scoped>
.ellipse {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 60px;
  display: block;
}
.con {
  text-align: left;
}
.rowTab {
  padding: 3px;
  color: black;
  background: #f8f8f8;
  font-size: 13px;
}
.rowTabcon {
  padding: 3px;
  color: black;
  background: #ffffff;
  font-size: 12px;
}
.info {
  color: gray;
  margin-top: 10px;
  padding: 10px;
  background: white;
  .padSty {
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .colorSty {
    color: #48bff4;
  }
}
</style>
